import { commonService } from './commonService';

export const softwareDevelopmentOutsourcing = {
  ...commonService,
  name: 'Software Development Outsourcing',
  serviceType: [
    'Software Development Outsourcing',
    'Frontend Development',
    'Backend Development',
    'Web Application Development',
    'Mobile Application Development',
    'Digital Product Development',
  ],
  description:
    'Boldare offers software development outsourcing services with dedicated teams specialized in frontend and backend development, web and mobile applications, and full digital product lifecycle support.',
};
